<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <image-zoom :asset="current" v-if="hasAssets && current"></image-zoom>
                <img src="/img/orbital/products/placeholder.png" itemprop="image" v-else style="max-width:100%">
            </div>
        </div>
        <template  v-if="hasMultiple">
        <hr>
        <div class="row mb--15">
            <div class="col-xs-4 col-md-3" v-for="asset in assets" :key="asset.id">
                <template v-if="asset.kind == 'youtube' || asset.kind == 'vimeo'">
                    <a :href="getVideoUrl(asset)" class="fresco">
                        <img src="/images/video-play.png" :alt="asset.title" itemprop="image" style="max-width:100%" v-if="!asset.thumbnail">
                        <img :src="asset.thumbnail" :alt="asset.title" itemprop="image" style="max-width:100%" v-else>
                    </a>
                </template>
                <template v-if="asset.kind == 'image'">
                    <a href="#" @click.prevent="swap(asset)">
                        <img :src="asset.url" :alt="asset.total" itemprop="image" style="max-width:100%">
                    </a>
                </template>

            </div>
        </div>
        </template>
    </div>
</template>

<script>
    import ImageZoom from '../Elements/ImageZoom.vue';

    export default {
        components: {
            ImageZoom
        },
        props: ['assets', 'thumbnail'],
        data() {
            return {
                hasAssets: true,
                current: null
            }
        },
        mounted() {
            if (!_.size(this.assets)) {
                this.hasAssets = false;
            }
            this.current = _.find(this.assets, asset => {
                return asset.primary;
            });
        },
        computed: {
            hasMultiple() {
                return _.size(this.assets) > 1;
            }
        },
        methods: {
            swap(asset) {
                this.current = asset;
            },
            getVideoUrl(asset) {
                let prefix = 'https://youtube.com/watch?v=';
                if (asset.type == 'vimeo') {
                    prefix = 'https://vimeo.com/';
                }
                return prefix + asset.url;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Product/ProductGallery.vue